// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__wGv8d","wordsWrapper":"Stats_wordsWrapper__ac278","word":"Stats_word__WridO"};